/* eslint-disable max-len */
/* eslint-disable prettier/prettier */

/**
 * This file can be used for unit tests.
 */
import {
  SubstanceUsageType,
  TriggerDisplayType,
  DailySummaryDto,
} from '@peartherapeutics/hylia-api-client';

export const cravingsTabInitialState: DailySummaryDto[] = [
  {
    date: '2022-08-13T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-14T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-15T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-16T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-17T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-18T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-19T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoUse,
    substanceUse: SubstanceUsageType.Used,
    triggers: [],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-08-20T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.Used,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 5,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 4,
      },
    ],
  },
  {
    averageCravingIntensity: 8,
    date: '2022-08-21T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.Used,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 5,
      },
    ],
  },
  {
    date: '2022-08-22T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-23T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoUse,
    substanceUse: SubstanceUsageType.Used,
    triggers: [],
  },
  {
    date: '2022-08-24T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.Used,
    triggers: [],
  },
  {
    date: '2022-08-25T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.Used,
    triggers: [],
  },
  {
    date: '2022-08-26T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-27T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-28T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.Used,
    triggers: [],
  },
  {
    date: '2022-08-29T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.Used,
    triggers: [],
  },
  {
    date: '2022-08-30T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-08-31T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-01T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-02T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-03T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-04T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-05T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.Used,
    triggers: [],
  },
  {
    date: '2022-09-06T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 9,
    date: '2022-09-07T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 5,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 6,
      },
    ],
  },
  {
    averageCravingIntensity: 7,
    date: '2022-09-08T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    averageCravingIntensity: 8,
    date: '2022-09-09T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 5,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 2,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 4,
      },
    ],
  },
  {
    averageCravingIntensity: 10,
    date: '2022-09-10T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 5,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-09-11T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-09-12T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoUse,
    substanceUse: SubstanceUsageType.Used,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 5,
      },
    ],
  },
  {
    averageCravingIntensity: 7,
    date: '2022-09-13T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-09-14T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    averageCravingIntensity: 7,
    date: '2022-09-15T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    averageCravingIntensity: 5,
    date: '2022-09-16T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    date: '2022-09-17T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-18T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-19T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 4,
    date: '2022-09-20T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    date: '2022-09-21T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-22T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-09-23T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    date: '2022-09-24T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-25T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-09-26T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-09-27T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.Used,
    triggers: [
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 4,
      },
    ],
  },
  {
    date: '2022-09-28T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-09-29T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    date: '2022-09-30T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 4,
    date: '2022-10-01T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 4,
      },
    ],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-10-02T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    date: '2022-10-03T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 5,
    date: '2022-10-04T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Angry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 5,
      },
    ],
  },
  {
    date: '2022-10-05T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-06T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoUse,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-07T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 4,
    date: '2022-10-08T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 4,
      },
    ],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-10-09T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 3,
      },
    ],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-10-10T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 5,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 4,
      },
    ],
  },
  {
    averageCravingIntensity: 5,
    date: '2022-10-11T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 4,
      },
    ],
  },
  {
    date: '2022-10-12T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-13T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-14T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-15T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-16T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-10-17T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.Used,
    triggers: [
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 4,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 4,
      },
    ],
  },
  {
    averageCravingIntensity: 5,
    date: '2022-10-18T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.SocialPressure,
        averageIntensity: 4,
      },
    ],
  },
  {
    date: '2022-10-19T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-20T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 6,
    date: '2022-10-21T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.Used,
    triggers: [
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 3,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 4,
      },
    ],
  },
  {
    date: '2022-10-22T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-23T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-24T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 4,
    date: '2022-10-25T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 1,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 5,
      },
    ],
  },
  {
    averageCravingIntensity: 4,
    date: '2022-10-26T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 1,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 5,
      },
    ],
  },
  {
    date: '2022-10-27T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-28T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-10-29T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    averageCravingIntensity: 2,
    date: '2022-10-30T00:00:00.000Z',
    medicationUse: SubstanceUsageType.Used,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 1,
      },
    ],
  },
  {
    averageCravingIntensity: 4,
    date: '2022-10-31T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoUse,
    triggers: [
      {
        type: TriggerDisplayType.Hungry,
        averageIntensity: 5,
      },
      {
        type: TriggerDisplayType.Lonely,
        averageIntensity: 2,
      },
    ],
  },
  {
    date: '2022-11-01T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoUse,
    substanceUse: SubstanceUsageType.Used,
    triggers: [],
  },
  {
    date: '2022-11-02T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-11-03T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-11-04T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-11-05T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-11-06T00:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-11-07T01:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-11-08T01:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
  {
    date: '2022-11-09T01:00:00.000Z',
    medicationUse: SubstanceUsageType.NoData,
    substanceUse: SubstanceUsageType.NoData,
    triggers: [],
  },
] as DailySummaryDto[];
